import { ReactComponent as PauseBtn } from "../assets/icons/general/stop.svg";
import { ReactComponent as PlayBtn } from "../assets/icons/general/play.svg";
import useAuth from "../hooks/Auth/useAuth";
import sendDrivingCommand from "../services/sendDrivingCommand";


export default function PausePlayCommand({ cartNumber }) { 

    const { cartsLocationsArr, relevantUrl} = useAuth();

    const cart = cartsLocationsArr.find(cart => cart.cart_number === cartNumber);
    const cartMotionStatus = cart.path_status === 'DRIVING' ? true : false;
    
    async function handlePausePlayClick() {
        await sendDrivingCommand(cartNumber, relevantUrl, cartMotionStatus ? 'pause' : 'drive');
    }

    

    return <span onClick={handlePausePlayClick} style={{fontSize:'20px'}}>{cartMotionStatus ? <PauseBtn/> : <PlayBtn/>}</span>;
}
